<div class="custom-container">
  <div class="filter-section">
    <app-custom-date-select
      [(ngModel)]="selectedDate"
      class="date-select"
      [minDate]="minDate"
      [maxDate]="maxDate"
      selectionMode="month-year"
      (dateChange)="onDateSelected($event)"
    />
  </div>

  <div class="first-table-scroll table-scroll-container">
    <div class="three-container">
      <div class="box">
        <div class="box-header dealers-header sticky-header">
          <input
            type="checkbox"
            [checked]="areAllDealersSelected"
            [disabled]="!hasSelectableDealers"
            (change)="toggleSelectAll('dealers', $event)"
          />
          Select Dealers
        </div>
        <div class="box-body scroll-body">
          @for (d of dealersList; track d.GroupMemberCode) {
            <div class="row-item">
              <label class="label-hover">
                <input
                  type="checkbox"
                  [(ngModel)]="d.selected"
                  [disabled]="!d.IsComposite"
                  [checked]="d.IsIncluded"
                  (change)="onPrimarySelectionChange()"
                />
                <span class="text-spacing">{{ d.GroupMemberCode }}</span>
              </label>
            </div>
          }
        </div>
      </div>

      <div class="box">
        <div class="box-header group-header sticky-header">
          <input
            type="checkbox"
            [checked]="areAllGroupAvgSelected"
            [disabled]="!isAnyDealerSelected"
            (change)="toggleSelectAll('group', $event)"
          />
          Select Group Average
        </div>
        <div class="box-body scroll-body">
          @for (g of groupAverageList; track $index) {
            <div class="row-item">
              <label class="label-hover">
                <input
                  type="checkbox"
                  [(ngModel)]="g.selected"
                  [disabled]="!isAnyDealerSelected"
                  (change)="onPrimarySelectionChange()"
                />
                <span class="text-spacing">{{ g.name }}</span>
              </label>
            </div>
          }
        </div>
      </div>

      <div class="box">
        <div class="box-header boc-header sticky-header">
          <input
            type="checkbox"
            [checked]="areAllBocSelected"
            (change)="toggleSelectAll('boc', $event)"
          />
          Select Best Of Class
        </div>
        <div class="box-body scroll-body">
          @for (b of bocList; track b.Composite_Id || $index) {
            <div class="row-item">
              <label class="label-hover">
                <input
                  type="checkbox"
                  [(ngModel)]="b.selected"
                  (change)="onPrimarySelectionChange()"
                />
                <span class="text-spacing">{{ b.CompositeTypeDesc }}</span>
              </label>
            </div>
          }
        </div>
      </div>

      <div class="box">
        <div class="box-header pages-header sticky-header">
          <input
            type="checkbox"
            [checked]="areAllPagesSelected"
            (change)="toggleSelectAll('pagelist', $event)"
          />
          Select Pages
        </div>
        <div class="box-body scroll-body">
          @for (d of pagesList; track $index) {
            <div class="row-item">
              <label class="label-hover">
                <input
                  type="checkbox"
                  [(ngModel)]="d.selected"
                  [disabled]="!d.IsComposite"
                  [checked]="d.IsIncluded"
                  (change)="onPrimarySelectionChange()"
                />
                <span class="text-spacing">{{ d.Page_Code }}</span>
              </label>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="second-table fixed-section">
    <p class="padding-11">Report Types</p>
    <table class="custom-table">
      <thead>
        <tr>
          @for (item of pageGroupingList; track item.PageGrouping_Type_Id) {
            <th>
              {{ item.Name }}
            </th>
          }
        </tr>
      </thead>
      <tbody>
        <tr>
          @for (item of pageGroupingList; track item.PageGrouping_Type_Id) {
            <td>
              <div class="cell-row">
                <label class="option">
                  <input
                    type="checkbox"
                    [(ngModel)]="checkboxModel[item.PageGrouping_Type_Id].P"
                    class="cell-spacing"
                    [disabled]="!isAnyPrimaryChecked"
                  />
                  <img
                    src="/assets/images/pdf-active.svg"
                    alt="PDF"
                    class="image-height"
                  />
                </label>
                <span class="divider"></span>

                <label class="option">
                  <input
                    type="checkbox"
                    [(ngModel)]="checkboxModel[item.PageGrouping_Type_Id].E"
                    class="cell-spacing"
                    [disabled]="!isAnyPrimaryChecked"
                  />
                  <span class="divider"></span>
                  <img
                    src="/assets/images/excel-active.png"
                    alt="Excel"
                    class="image-height"
                  />
                </label>
              </div>
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>

  <div class="generate-report">
    <button
      class="add-button"
      (click)="generateReports()"
      [disabled]="!isAnyExcelPdfChecked"
    >
      Generate Reports
    </button>
  </div>
</div>
